export enum BuildingType {
  AIRPORT = "AIRPORT",

  OFFICE_BUILDING = "OFFICE_BUILDING",

  CHEMISTRY_PHARMA = "CHEMISTRY_PHARMA",

  SHOPPING_MALL = "SHOPPING_MALL",

  INDUSTRIAL_HALL = "INDUSTRIAL_HALL",

  MEDICAL_PRACTICE = "MEDICAL_PRACTICE",
  HOSPITAL = "HOSPITAL",

  HOTEL = "HOTEL",

  CINEMA = "CINEMA",
  THEATER = "THEATER",

  FAIR = "FAIR",
  MUSEUM = "MUSEUM",

  CHURCH = "CHURCH",

  RESTAURANT = "RESTAURANT",

  SCHOOL = "SCHOOL",

  UNDERGROUND_CAR_PARK = "UNDERGROUND_CAR_PARK",

  SPORTS_FACILITY = "SPORTS_FACILITY",

  RECORDING_STUDIO = "RECORDING_STUDIO",

  ASSEMBLY_BUILDING = "ASSEMBLY_BUILDING",

  RESIDENTIAL_BUILDING = "RESIDENTIAL_BUILDING"
}
